import { Suspense, useEffect, useState } from "react";
import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import { ExternalLink, LogOut, Menu, Moon, Sun } from "lucide-react";
import logo from "../assets/phelifla-logo.png";
import { useAuth } from "../contexts/AuthContext";
import { useTheme } from "../contexts/ThemeContext";
import { NAV } from "../routes";
import { Avatar, Button, Loader } from "./ui";
import ErrorBoundary from "./ErrorBoundary";

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const { isDark, toggleTheme } = useTheme();
  const { pathname } = useLocation();
  const [menuAberto, setMenuAberto] = useState(false);

  // Fecha o menu do celular ao trocar de página.
  useEffect(() => setMenuAberto(false), [pathname]);

  return (
    <div className={`shell${menuAberto ? " menu-open" : ""}`}>
      <aside className="sidebar" aria-label="Menu principal">
        <Link to="/" className="sidebar__brand">
          <img src={logo} alt="" className="sidebar__logo" />
          <div>
            <div className="sidebar__name">
              Pheli<span>Fla</span>
            </div>
            <div className="sidebar__tag">Painel administrativo</div>
          </div>
        </Link>

        <nav className="sidebar__nav">
          {NAV.map((grupo, i) => (
            <div className="nav-group" key={grupo.label ?? i}>
              {grupo.label && <div className="nav-group__label">{grupo.label}</div>}
              {grupo.items.map(({ path, label, icon: Icon }) => (
                <NavLink key={path} to={path} end={path === "/"} className="nav-link">
                  <Icon size={17} />
                  {label}
                </NavLink>
              ))}
            </div>
          ))}
          <div className="nav-group">
            <div className="nav-group__label">Público</div>
            <a className="nav-link" href="/privacidade" target="_blank" rel="noreferrer">
              <ExternalLink size={17} />
              Política de privacidade
            </a>
          </div>
        </nav>

        <div className="sidebar__footer">
          <Avatar src={user?.photoURL} name={user?.displayName || user?.email} size="sm" />
          <div className="sidebar__user">
            <strong>{user?.displayName || "Administrador"}</strong>
            <span>{user?.email}</span>
          </div>
          <Button
            variant="ghost"
            size="sm"
            icon={isDark ? Sun : Moon}
            onClick={toggleTheme}
            title={isDark ? "Tema claro" : "Tema escuro"}
            aria-label={isDark ? "Usar tema claro" : "Usar tema escuro"}
          />
          <Button variant="ghost" size="sm" icon={LogOut} onClick={logout} title="Sair" aria-label="Sair" />
        </div>
      </aside>

      <div className="scrim" onClick={() => setMenuAberto(false)} />

      <div className="main">
        <header className="topbar">
          <Button variant="ghost" icon={Menu} onClick={() => setMenuAberto(true)} aria-label="Abrir menu" />
          <img src={logo} alt="" className="sidebar__logo" style={{ width: 28, height: 28 }} />
          <strong>PheliFla Admin</strong>
        </header>
        <main className="content">
          <ErrorBoundary key={pathname}>
            <Suspense fallback={<Loader />}>
              <Outlet />
            </Suspense>
          </ErrorBoundary>
        </main>
      </div>
    </div>
  );
}
